/* IA Comparison table — mobile column switcher.
   A row of thumbnails (one per non-current column) toggles which "other"
   column shows beside the pinned current-product column. Desktop shows every
   column, so this only toggles classes the mobile CSS reads — the default
   active column comes from CSS, so there is no first-paint flash.
   The variant select + add-to-bag wiring is reused from <ia-product-card>. */
if (!customElements.get('ia-comparison-table')) {
  class IaComparisonTable extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('click', this.handleClick.bind(this), {
        signal: this.abortController.signal,
      });
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.abortController.abort();
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick(event) {
      const thumb = event.target.closest('[data-compare-thumb]');
      if (thumb) this.activate(thumb.dataset.compareKey);
    }

    // Theme editor: reveal a column when its block is selected.
    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const column = event.target.querySelector('[data-compare-col-other]');
      if (column) this.activate(column.dataset.compareKey);
    }

    activate(key) {
      if (!key) return;
      this.querySelectorAll('[data-compare-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.compareKey === key);
      });
      this.querySelectorAll('[data-compare-col-other]').forEach((column) => {
        column.classList.toggle('is-active', column.dataset.compareKey === key);
      });
    }
  }

  customElements.define('ia-comparison-table', IaComparisonTable);
}
